import React from 'react';
import { Icon, Ref } from 'semantic-ui-react';
import { ButtonLink, Table } from 'dyl-components';
import { Link } from 'react-router-dom';
import OfficeViewDestinationActiveCall from '../../atoms/OfficeViewDestinationActiveCall';
import { useDroppable } from '@dnd-kit/core';
import './OfficeViewUser.scss';

const OfficeViewUser = ({
    togglePin,
    isInPinnedTab,
    isPinLimitReached,
    user,
    userPhoneCreds,
    onClickToDialList,
    onEmailClick,
    hasIntegration,
    onListen,
    isListeningToCall
}) => {
    const isPinDisabled = !user.pinned && (isInPinnedTab || isPinLimitReached);
    const user_id = user.user_id;
    const { isOver, setNodeRef, active: callOverUser } = useDroppable({
        id: `teams-${user_id}`,
        data: {
            type: 'office-view-user',
            target: user.extension_number
        }
    });

    const { isOver: isOverCell, setNodeRef: setNodeRefCell, active: callOverCell } = useDroppable({
        id: `teams-cell-${user_id}`,
        disabled: !user.cell_phone,
        data: {
            type: 'office-view-user-cell',
            target: user.cell_phone,
            user_id: user_id
        }
    });

    const { isOver: isOverVoicemail, setNodeRef: setNodeRefVoicemail, active: callOverVoicemail } = useDroppable({
        id: `teams-voicemail-${user_id}`,
        disabled: !user.voicemail_ext,
        data: {
            type: 'office-view-user-voicemail',
            target: `voicemail_${user.voicemail_ext}`
        }
    });

    const elementName = 'OfficeViewUser';

    const getCallDestinationClassName = (isDraggingOver, hasIcon) => {
        const baseClassName = `${elementName}__call-destination`;
        return [
            baseClassName,
            isDraggingOver && `${baseClassName}--dragging-over`,
            hasIcon && `${baseClassName}--with-icon`
        ].filter(Boolean).join(' ');
    }

    return (
        <Table.Row loading={false}>
            <Table.Cell>
                <div className={`${elementName}__details`}>
                    <ButtonLink disabled={isPinDisabled} noPadding onClick={(event) => {
                        togglePin(user.extension_id, !user.pinned)
                        event.stopPropagation();
                    }}>
                        <Icon className={`fa-solid fa-thumbtack ${elementName}__pin${user.pinned ? "--active" : ""}`} size={"large"} />
                    </ButtonLink>
                    <div className={`${elementName}__name-with-extension`}>
                        {user.first_name && (
                            <Link to={`/settings/users/${user.user_id}/general`} target='_blank' rel='noopener noreferrer'>{`${user.first_name} ${user.last_name}`}</Link>
                        )}
                        <span>
                            {user.extension_number ? `Ext. ${user.extension_number}` : ""}
                        </span>
                    </div>
                </div>
            </Table.Cell>
            <Ref innerRef={setNodeRef}>
                <Table.Cell className={getCallDestinationClassName(isOver && !callOverUser?.data?.current?.isInternal)}>
                    {user_id && user.activeCalls?.map((call) => <OfficeViewDestinationActiveCall
                        call={call}
                        type={"teams"}
                        key={call.uuid}
                        userPhoneCreds={userPhoneCreds}
                        onListen={onListen && !isListeningToCall ? () => onListen(call) : undefined}
                    />)}
                </Table.Cell>
            </Ref>
            <Ref innerRef={setNodeRefVoicemail}>
                <Table.Cell className={getCallDestinationClassName(isOverVoicemail && !callOverVoicemail?.data?.current?.isInternal, true)}>
                    {user_id && (
                        <Icon className={`fa-solid fa-voicemail ${elementName}__icon`} size={"large"} disabled={!user.voicemail_ext} />
                    )}
                </Table.Cell>
            </Ref>
            <Ref innerRef={setNodeRefCell}>
                <Table.Cell className={getCallDestinationClassName(isOverCell && !callOverCell?.data?.current?.isInternal, true)}>
                    {user_id && (
                        <Icon className={`fa-solid fa-mobile-screen-button ${elementName}__icon`} size={"large"} disabled={!user.cell_phone} />
                    )}
                </Table.Cell>
            </Ref>
            <Table.Cell>
                {user_id && (
                    <div className={`${elementName}__actions`}>
                        <ButtonLink style={{flex: 1}} onClick={(event) => {
                            event.stopPropagation();
                            const payload = {
                                destination: user?.extension_number,
                                to_user_id: user.user_id
                            }
                            onClickToDialList(payload)
                        }}>
                            <Icon className='fa-solid fa-phone OfficeViewTeamsResults__linkIcon--pinned' size={"large"} disabled={!!!user?.extension_number}/>
                        </ButtonLink>
                        <ButtonLink style={{flex: 1}} onClick={() => 
                        { 
                            if(!hasIntegration) return
                            return onEmailClick(`${user.first_name} ${user.last_name}`, user.email)}
                        }>
                            <Icon className={`fa-solid fa-envelope ${elementName}__icon`} size={"large"} disabled={!hasIntegration}/>
                        </ButtonLink>
                    </div>
                )}
            </Table.Cell>
        </Table.Row>
    )
}

export default OfficeViewUser;
